import {zodResolver} from '@hookform/resolvers/zod'
import {
    resetPasswordField,
    resetPasswordFieldValidation,
} from 'constants/FormField/forgotPasswordField'
import useResponsive from 'logic/useResponsive'
import {useForm} from 'react-hook-form'
import {useTranslation} from 'react-i18next'
import {useNavigate, useParams} from 'react-router-dom'
import {toast} from 'sonner'
import {useResetPasswordMutation} from 'store/Store'

const useResetPassword = ({i18nCategory}) => {
    const {mediumScreen} = useResponsive()
    const navigate = useNavigate()
    const methods = useForm({
        resolver: zodResolver(resetPasswordFieldValidation),
    })
    const {handleSubmit} = methods
    const {t} = useTranslation()
    const {token} = useParams()
    const [doSubmit, {error}] = useResetPasswordMutation()

    const onSubmit = (data) => {
        toast.promise(
            doSubmit({token, data})
                .unwrap()
                .then(() => {
                    navigate('/login')
                })
                .catch((error) => {
                    console.log('toast error', error)
                    throw error
                }),
            {
                loading: t('loading'),
                success: () => t(`${i18nCategory}.success`),
                error: () => t(`${i18nCategory}.error`),
            }
        )
    }

    return {
        handleSubmit,
        onSubmit,
        error,
        mediumScreen,
        methods,
        t,
        formField: resetPasswordField,
    }
}

export default useResetPassword
